// NFS-e recorrentes: mensalidades e contratos emitidos automaticamente todo mês.
import React, { useEffect, useState } from "react";
import { fiscal } from "../api";
import { Aviso, Botao, Campo, Cartao, Entrada, StatusNota, Tabela } from "../components/ui";
import { brl, dataBR } from "../utils";
import NFSeForm from "./NFSeForm";
import { AvisoDocumentoBloqueado } from "../components/DocumentoLiberado";

export default function Recorrentes({ emissor }) {
  const [lista, setLista] = useState([]);
  const [editando, setEditando] = useState(null); // null | "nova" | registro
  const [cab, setCab] = useState({ nome: "", dia_mes: 5, ativo: true });
  const [msg, setMsg] = useState(null);
  const carregar = () => fiscal.recorrentes().then(setLista).catch((e) => setMsg({ tipo: "erro", texto: e.message }));
  useEffect(() => { carregar(); }, []);

  const abrir = (r) => {
    setMsg(null);
    if (r === "nova") setCab({ nome: "", dia_mes: 5, ativo: true });
    else setCab({ nome: r.nome, dia_mes: r.dia_mes, ativo: r.ativo });
    setEditando(r);
  };

  const salvar = async (dados) => {
    if (cab.nome.trim().length < 2) throw new Error("Dê um nome para a recorrência");
    const corpo = { ...cab, dia_mes: Number(cab.dia_mes), dados };
    if (editando === "nova") await fiscal.criarRecorrente(corpo);
    else await fiscal.atualizarRecorrente(editando.id, corpo);
    setEditando(null);
    setMsg({ tipo: "sucesso", texto: "Recorrência salva." });
    carregar();
  };

  const emitirAgora = async (r) => {
    setMsg(null);
    try {
      const res = await fiscal.emitirRecorrenteAgora(r.id);
      setMsg({ tipo: res.status === "autorizada" ? "sucesso" : "atencao", texto: `${r.nome}: ${res.status}${res.mensagem ? ` — ${res.mensagem}` : ""}` });
      carregar();
    } catch (e) {
      setMsg({ tipo: "erro", texto: e.message });
    }
  };

  const alternar = async (r) => {
    await fiscal.atualizarRecorrente(r.id, { nome: r.nome, dia_mes: r.dia_mes, ativo: !r.ativo, dados: r.dados });
    carregar();
  };

  if (editando) {
    return (
      <div className="space-y-4">
        <Cartao titulo={editando === "nova" ? "Nova recorrência" : `Editar: ${editando.nome}`}>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
            <Campo rotulo="Nome" className="md:col-span-2"><Entrada value={cab.nome} placeholder="Ex.: Mensalidade Cliente X" onChange={(e) => setCab((c) => ({ ...c, nome: e.target.value }))} /></Campo>
            <Campo rotulo="Dia do mês" dica="1 a 28, às 8h"><Entrada type="number" min="1" max="28" value={cab.dia_mes} onChange={(e) => setCab((c) => ({ ...c, dia_mes: e.target.value }))} /></Campo>
            <div className="flex items-end"><Botao variante="secundario" onClick={() => setEditando(null)}>Voltar</Botao></div>
          </div>
        </Cartao>
        <NFSeForm emissor={emissor} modoRecorrente notaRejeitada={editando === "nova" ? undefined : editando.dados} onSalvarRecorrente={salvar} />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <AvisoDocumentoBloqueado tipo="nfse" />
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">NFS-e recorrentes</h1>
        <Botao onClick={() => abrir("nova")}>+ Nova recorrência</Botao>
      </div>
      <p className="text-sm text-gray-600">As notas são emitidas automaticamente no dia escolhido. O resultado de cada emissão aparece abaixo e na lista de notas.</p>
      {msg && <Aviso tipo={msg.tipo}>{msg.texto}</Aviso>}
      <Cartao>
        <Tabela
          chave={(r) => r.id}
          linhas={lista}
          vazio="Nenhuma recorrência cadastrada"
          colunas={[
            { id: "nome", rotulo: "Nome" },
            { id: "tomador", rotulo: "Tomador", render: (r) => r.dados?.destinatario?.nome || "—" },
            { id: "valor", rotulo: "Valor", direita: true, render: (r) => brl(r.dados?.valor_servico) },
            { id: "dia_mes", rotulo: "Dia" },
            { id: "proxima_em", rotulo: "Próxima", render: (r) => (r.ativo ? dataBR(r.proxima_em) : "Pausada") },
            { id: "ultima", rotulo: "Última", render: (r) => {
              const u = (r.ultimas || []).at(-1);
              return u ? <span title={u.mensagem || ""}>{dataBR(u.em)} <StatusNota status={u.status} /></span> : "—";
            } },
            { id: "x", rotulo: "", render: (r) => (
              <span className="whitespace-nowrap">
                <Botao variante="fantasma" onClick={() => abrir(r)}>Editar</Botao>
                <Botao variante="fantasma" onClick={() => emitirAgora(r)}>Emitir agora</Botao>
                <Botao variante="fantasma" onClick={() => alternar(r)}>{r.ativo ? "Pausar" : "Ativar"}</Botao>
                <Botao variante="fantasma" className="text-red-600" onClick={() => fiscal.removerRecorrente(r.id).then(carregar)}>Excluir</Botao>
              </span>
            ) },
          ]}
        />
      </Cartao>
    </div>
  );
}
